import { addCommas } from "@persian-tools/persian-tools";
import { ImCancelCircle } from "react-icons/im";

import { TimeStampToJalali, pathMaker } from "utils/helperFunctions";
import "./finance-style.scss";

export default function FinanceCard({ data, TRANSACTION_TYPE, cancelFunc }) {
  return (
    <div
      className={`finance-card-style ${
        data?.status == -1 ? "bg-cancel" : "bg-active"
      }`}
    >
      <div className="contain w-md">
        <div className="title"> تراکنش</div>
        <div className="content">
          {
            TRANSACTION_TYPE?.find((v) => v?.value == data?.transaction_type)
              ?.label
          }
        </div>
      </div>
      <div className="contain w-lg">
        <div className="title"> کارت بانکی</div>
        <div className="content">
          {data?.bank_account?.[0]?.title}&nbsp;(
          {data?.bank_account?.[0]?.cardNumber})
        </div>
      </div>
      <div className="contain w-md">
        <div className="title"> مبلغ(تومان)</div>
        <div className="content">{addCommas(data?.amount)}</div>
      </div>
      <div className="contain w-lg">
        <div className="title"> طرف حساب</div>
        <div className="content">
          {data?.to_user?.[0]?.mobile != undefined ? (
            <>
              {data?.to_user?.[0]?.fname}&nbsp;{data?.to_user?.[0]?.lname}(
              {data?.to_user?.[0]?.mobile})
            </>
          ) : (
            "---"
          )}
        </div>
      </div>
      <div className="contain w-md">
        <div className="title"> زمان ثبت</div>
        <div className="content">
          {TimeStampToJalali(parseInt(data?.mtm) * 1000, "YYYY/MM/DD")}
        </div>
      </div>
      <div className="contain w-md">
        <div className="title"> زمان پرداخت</div>
        <div className="content">
          {TimeStampToJalali(parseInt(data?.pay_tm) * 1000, "YYYY/MM/DD")}
        </div>
      </div>
      <div className="contain w-md">
        <div className="title"> کدرهگیری</div>
        <div className="content">{data?.tracking_code}</div>
      </div>
      <div className="contain w-lg">
        <div className="title"> توضیحات</div>
        <div className="content">
          {data?.description != "" ? data?.description : "----"}
        </div>
      </div>
      <div className="contain w-md">
        <div className="title"> فایل</div>
        <div className="content">
          {data?.file?.[0]?.url != undefined &&
          data?.file?.[0]?.url != "" &&
          data?.file?.[0]?.url != "" ? (
            <a href={pathMaker(data?.file?.[0]?.url)} target="_blank">
              <img
                src={pathMaker(data?.file?.[0]?.url)}
                className="rounded"
                style={{ width: 50, height: 50, objectFit: "contain" }}
              />
            </a>
          ) : (
            <div>---</div>
          )}
        </div>
      </div>
      {data?.status == -1 && (
        <>
          <div className="contain w-md">
            <div className="title"> زمان ابطال</div>
            <div className="content">
              {TimeStampToJalali(parseInt(data?.uptm) * 1000, "YYYY/MM/DD")}
            </div>
          </div>
          <div className="contain w-md">
            <div className="title"> ابطال کننده</div>
            <div className="content">
              {data?.upuid?.[0]?.fname}&nbsp;{data?.upuid?.[0]?.lname}(
              {data?.upuid?.[0]?.mobile})
            </div>
          </div>
        </>
      )}
      {data?.status != -1 && (
        <div className="contain w-sm">
          <div className="title"> عملیات</div>
          <div
            className="content cursor-pointer"
            onClick={() => {
              cancelFunc(data);
            }}
          >
            <ImCancelCircle style={{ width: 18, height: 18 }} color="red" />
          </div>
        </div>
      )}
    </div>
  );
}
